import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import State from 'src/application/core/State';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import RequestFailed from '../../core/events/RequestFailed';
import OrderImportRequested from '../events/OrderImportRequested';
import OrderImportSucceed from '../events/OrderImportSucceed';
import OrderImportFailed from '../events/OrderImportFailed';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(OrderImportRequested.type),
        mergeMap((event: OrderImportRequested) => {
            return backend.post(`${api()}order/import`, JSON.stringify(event.rows)).pipe(
                map(
                    (ajaxResponse: AjaxResponse) =>
                        new OrderImportSucceed(ajaxResponse.response.articlesOrdersDrafts, ajaxResponse.response.itemValidationResult)
                ),
                catchError((e: AjaxError) => of(new OrderImportFailed(e.response), new RequestFailed(e.status)))
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/order/epic/orderImport.ts